<template>
    <div>
        <mobileDesktop
            :min_price="min_price"
            :max_price="max_price"
            :get_filter="get_filter"
            :category="category"
            :object_type="object_type"
            :sales="sales"
            @change="change"
        />
    </div>
</template>

<script>
import mobileDesktop from "./filter_products_parts/MobileDesktop";
import filter from "./../mixins/filter";

export default {
    components: {
        mobileDesktop
    },
    mixins: [
        filter
    ],
    mounted() {
        this.$emit("preloadFilterQuery", this.get_filter);
    }
}
</script>
